import type { CaptionUpdatePanelFragment } from "../../client/generated";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { AttributePanel } from "../AttributePanel";
import { CaptionFormField } from "./CaptionFormField";
import {
  useDeleteCaptionFromPanelMutation,
  useUpdateCaptionFromPanelMutation,
} from "../../client/generated";

type Props = {
  fragment: CaptionUpdatePanelFragment;
};

export function CaptionUpdatePanel({ fragment }: Props) {
  const { t } = useTranslation();
  const [updateAttribute] = useUpdateCaptionFromPanelMutation();
  const [deleteAttribute] = useDeleteCaptionFromPanelMutation();
  const [linkedRegionId, setLinkedRegionId] = useState(
    fragment.linkedRegion?.id,
  );

  const onSave = async () => {
    await updateAttribute({
      variables: {
        attributeId: fragment.id,
        linkedRegionId,
      },
    });
  };

  const onDelete = async () => {
    await deleteAttribute({
      variables: { attributeId: fragment.id },
      update(cache) {
        const id = cache.identify(fragment);
        cache.evict({ id });
        cache.gc();
      },
    });
  };

  return (
    <AttributePanel
      title={t("CaptionUpdatePanel.title")}
      unsaved={linkedRegionId !== fragment.linkedRegion?.id}
      onSubmit={onSave}
      onDelete={onDelete}
    >
      <CaptionFormField
        fragment={fragment.region}
        value={linkedRegionId ?? ""}
        onValueChange={setLinkedRegionId}
      />
    </AttributePanel>
  );
}
